import axios from "axios";
import { toast } from "sonner";
import { API } from "./apiClient";

export const UNDO_MS = 10000;

export function undoToast(message, onUndo) {
  toast(message, {
    duration: UNDO_MS,
    action: {
      label: "Geri al",
      onClick: async () => {
        try { await onUndo(); toast.success("Geri alındı"); } catch (e) { toast.error(e?.response?.data?.detail || "Geri alınamadı"); }
      },
    },
  });
}

export const restoreFromTrash = async (trashId) => (await axios.post(`${API}/trash/items/${trashId}/restore`)).data.item;
